import { render, staticRenderFns } from "./PolicyPrivacy.vue?vue&type=template&id=1788d095&"
import script from "./PolicyPrivacy.vue?vue&type=script&lang=js&"
export * from "./PolicyPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports